import moment from 'moment'
import commonsService from '../commons.service'
export const SECOND = 1000
export const MINUTE = 60 * SECOND
export const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR

export function formatDate (date) {
  const d = date instanceof Date ? date : new Date(date)
  return new Intl
    .DateTimeFormat('en-US')
    .format(d)
}

export function formatTime (date) {
  const d = date instanceof Date ? date : new Date(date)
  return new Intl
    .DateTimeFormat('en-US', { timeStyle: 'short' })
    .format(d)
    .toLowerCase()
}

export function getHumanReadableTime (date, options = {}) {
  const isMobile = commonsService.isMobile()
  const d = date instanceof Date ? date : new Date(date)
  const { now = new Date() } = options
  const diff = now - d

  if (diff < 120 * SECOND) return !isMobile ? 'Just a moment ago' : 'Now'

  if (diff <= 10 * MINUTE) return parseInt(diff / MINUTE) + ' minutes ago'

  if (diff < HOUR) return !isMobile ? 'Less than one hour ago' : '< 1h ago'

  const hours_ago = parseInt(diff / HOUR)

  if (hours_ago === 1) return '1 hour ago'

  if (hours_ago <= 6) return `${hours_ago} hours ago`

  if (hours_ago <= 48) {
    if (isMobile) return moment(formatDate(d), 'M/D/YYYY').format('MM/DD/YYYY')
    return (d.getDay() === now.getDay()
      ? 'Today'
      : 'Yesterday') +
      ' at ' + formatTime(d)
  }

  if (diff <= 5 * DAY) return `${parseInt(diff / DAY)} days ago`

  return moment(formatDate(d), 'M/D/YYYY').format('MM/DD/YYYY')
}
